import { useState, useEffect } from 'react';
import { studentAPI } from '@/services/api';

const subjectColors = [
  'from-emerald-500 to-emerald-700',
  'from-blue-500 to-blue-700',
  'from-purple-500 to-purple-700',
  'from-amber-500 to-amber-700',
  'from-rose-500 to-rose-700',
  'from-cyan-500 to-cyan-700',
  'from-indigo-500 to-indigo-700',
  'from-teal-500 to-teal-700',
];

const subjectIcons = [
  'fa-calculator',
  'fa-language',
  'fa-mosque',
  'fa-atom',
  'fa-flask',
  'fa-dna',
  'fa-globe-africa',
  'fa-laptop-code',
];

const StudentSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Subjects will be fetched from API when backend endpoint is available
    // For now, show empty state
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-black text-slate-800">My Subjects</h2>
      </div>

      {subjects.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {subjects.map((subject, idx) => (
            <div
              key={subject.id || idx}
              className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all overflow-hidden group"
            >
              <div className={`h-2 bg-gradient-to-r ${subjectColors[idx % subjectColors.length]}`} />
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${subjectColors[idx % subjectColors.length]} flex items-center justify-center text-white shadow-lg`}>
                    <i className={`fas ${subjectIcons[idx % subjectIcons.length]} text-xl`} />
                  </div>
                </div>
                <h3 className="font-bold text-slate-800 text-lg mb-1 group-hover:text-emerald-600 transition-colors">
                  {subject.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-12 text-center">
          <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="fas fa-book text-2xl text-slate-300" />
          </div>
          <h3 className="font-bold text-slate-600 mb-1">No Subjects</h3>
          <p className="text-sm text-slate-400">Your subjects will appear here once assigned.</p>
        </div>
      )}
    </div>
  );
};

export default StudentSubjects;

